import React, {useState} from 'react';
import HidePassword from './Icons/hidePassword.svg'
import ShowPassword from './Icons/showPassword.svg'
import PropTypes from 'prop-types'
import styled from "styled-components";

PasswordInput.propTypes = {
    reff: PropTypes.any
};

function PasswordInput(props) {
    const [passwordVisibility, setPasswordVisibility] = useState(false)

    return (
        <div key={props.keyss} className="form__option">
            <label htmlFor={'password'}>Пароль{props.important && <span style={{color: 'red'}}>*</span>}</label>
            <InputWrapper>
                <input
                    autoComplete={'off'}
                    aria-autocomplete={'none'}
                    ref={props.important ? props.reff({
                        required: "Выберите пароль",
                        minLength: {
                            value: 6,
                            message: 'Минимальная длина пароля - 6 символов'
                        },
                        maxLength: {
                            value: 15,
                            message: 'Максимальная длина пароля - 15 символов'
                        },
                        validate: {
                            password: value => /^[A-Za-z0-9]+$/.test(value) || `Пароль должен состоять из латинских символов`,
                        }
                    }) : props.reff()}
                    defaultValue={props.defaultValue}
                    onChange={props.onChange}
                    placeholder={props.placeholder}
                    id={props.name}
                    className={`form-input ${props.className}`}
                    name={'password'}
                    disabled={props.disabled}
                    type={passwordVisibility ? 'text' : 'password'}
                    required={props.required}
                    min={props.min}
                    minLength={props.minLength}
                    max={props.max}
                    maxLength={props.maxLength}
                    value={props.value}
                    pattern={props.pattern}
                />
                <StyledIcon>
                    <img alt={'visibility'} src={passwordVisibility ? ShowPassword : HidePassword}
                         onClick={_ => setPasswordVisibility(!passwordVisibility)}/>
                </StyledIcon>

            </InputWrapper>
        </div>


    );
}

const StyledIcon = styled.div`
  position: absolute;
  right: 20px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;

  img {
    transition: 2000ms;
    width: 30px;
    top: 0;
    position: unset !important;
    cursor: pointer;
    @media(max-width: 1100px){
      width: 15px;
    }
  }
`
const InputWrapper = styled.div`
  position: relative;
  margin-top: 6px;

  input {
    margin-top: 0;
  }

`


export default PasswordInput;

